import angular from 'angular';
import uiRouter from 'angular-ui-router';
import productComponent from './product.component';
import productFactory from './product.factory';

const productModule = angular
  .module('product', [uiRouter])
  .component('product', productComponent)
  .factory('Product', productFactory)
  .config(($stateProvider) => {
    'ngInject';

    $stateProvider.state('product', {
      url: '/product',
      component: 'product',
    });
  }).name;

export default productModule;



// WEBPACK FOOTER //
// ./client/app/components/product/product.js